/**
 * Sets http response as Class(response)
 *
 * @param Class - can be and Class or [Class] to map every result
 * @param constructorArgs - args to send to Class constructor
 *
 * @author rodrigo@kissolutions.tech
 */
export function ApiResponse(Class: any, ...constructorArgs: any) {
  return (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor,
  ) => {
    const original = descriptor.value;
    descriptor.value = async function( ...args: any[]) {
      const response = await original.apply(this, args);
      if(Array.isArray(Class)) {
        return response.map((r) => new Class[0](r, ...constructorArgs));
      } else {
        return new Class(response, ...constructorArgs);
      }
    }
  };
}
